import { useState } from "react";
import { ChatContext } from "./ChatContext";

const ChatProvider = ({ children }) => {
  // Chat state and logic would go here
  const [currentContext, setCurrentContext] = useState(null);
  const [isFullScreen, setIsFullScreen] = useState(false);

  return (
    <ChatContext.Provider
      // oxlint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        currentContext,
        setCurrentContext,
        isFullScreen,
        setIsFullScreen,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export default ChatProvider;
